import React from "react";
import { Modal } from "react-bootstrap";
import StandardButton from "../../../shared/formComponents/StandardButton/StandardButton";
import "./DiscontinueInvitePopup.scss";
const DiscontinueInvitePopup = (props) => {
  return (
    <Modal
      show={props.open}
      onHide={props.handleClose}
      fullscreen="sm-down"
      size="lg"
      id="discontinue-invite-popup"
      centered
      scrollable
    >
      <Modal.Header closeButton className="border-bottom p-4">
        <div className="d-flex align-items-center header-content">
          <div className="img-container">
            <img src="/assets/images/announcement-icon.svg" />
          </div>
          <p className="mb-0 ms-3">Invite SME Feature Discontinued</p>
        </div>
      </Modal.Header>
      <Modal.Body className="px-4 py-3">
        <div className="my-3">
          <p className="content">
            We've discontinued the Invite SME functionality on the Coach
            platform. Please ask your SME to sign up directly using this link:{" "}
            <a
              href="https://app.artofscale.io/auth/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-underline"
            >
              https://app.artofscale.io/auth/signup
            </a>
          </p>
          <p className="content mb-0">
            If you have any questions, feel free to contact us at{" "}
            <a
              href={`mailto:support@artofscale.io`}
              className="text-decoration-underline"
            >
              support@artofscale.io
            </a>{" "}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex align-items-center justify-content-center border-top p-4">
        <StandardButton
          text="Okay"
          icon={<img src="/assets/images/right-arrow-white.svg" />}
          color="btn-success"
          className="btn-md py-0 px-3"
          textClassName="m-0"
          onClick={props.handleClose}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default DiscontinueInvitePopup;
